import React, { useState } from "react";
import axios from "axios";
import { Table, Card, Typography, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import useServerPagination from "Common/hooks/useServerPagination";

const { Paragraph } = Typography;

// Fetch a page of the manager's training progress reports.
const fetchReports = async ({ pageNumber, pageSize, orderByLatest }) => {
  const token = localStorage.getItem("token");
  const response = await axios.get(
    `${process.env.REACT_APP_API_URL}/TrainingProgressReport/Manager/List`,
    {
      params: { pageNumber, pageSize, orderByLatest },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const TrainingStatusReport = () => {
  const navigate = useNavigate();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const { items, loading, paginationProps } = useServerPagination(fetchReports, {}, {
    onError: () => message.error("Failed to load training progress reports"),
  });

  const toggleExpand = (id) => {
    if (expandedRowKeys.includes(id)) {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key !== id));
    } else {
      setExpandedRowKeys([...expandedRowKeys, id]);
    }
  };

  const columns = [
    {
      title: "Learner Name",
      dataIndex: "learnerName",
      key: "learnerName",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: "Report",
      dataIndex: "reportText",
      key: "reportText",
      render: (text, record) => {
        const isExpanded = expandedRowKeys.includes(record.id);
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "4px",
            }}
          >
            <Paragraph
              ellipsis={
                !isExpanded
                  ? {
                      rows: 3,
                    }
                  : false
              }
              style={{ maxWidth: 400, width: "100%", marginBottom: "0" }}
            >
              {text}
            </Paragraph>
            <Button type="link" onClick={() => toggleExpand(record.id)} style={{ padding: 0 }}>
              {isExpanded ? "Show less" : "Read more"}
            </Button>
          </div>
        );
      },
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Button type="primary" onClick={() => navigate(`/report-Detail/${record.id}`)}>
          View Detail
        </Button>
      ),
    },
  ];

  return (
    <Card loading={loading} title="Training Progress Reports" className="card-professional">
      <Table
        columns={columns}
        dataSource={items}
        rowKey="id"
        pagination={paginationProps}
        bordered
        scroll={{ x: "max-content" }}
      />
    </Card>
  );
};

export default TrainingStatusReport;
